import store from "../store";

export default function (to, from, next) {
    if (!store.getters['authStore/isAdmin']) {
        return next('/app');
    }

    return next();
}
